(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('LeadDiscount', LeadDiscount);

    LeadDiscount.$inject = ['$resource'];

    function LeadDiscount ($resource) {
        var resourceUrl =  'api/lead-discounts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
